(function() {
  function initProductSection() {
    // 1. Size Guide Modal Toggler
    var sizeGuideTrigger = document.getElementById("size-guide-trigger");
    var sizeGuideModal = document.getElementById("size-guide-modal");
    var sizeGuideClose = document.getElementById("size-guide-close");

    if (sizeGuideTrigger && sizeGuideModal && sizeGuideClose) {
      // Clone to purge old event listeners on re-run
      var newTrigger = sizeGuideTrigger.cloneNode(true);
      sizeGuideTrigger.parentNode.replaceChild(newTrigger, sizeGuideTrigger);
      
      var newCloseBtn = sizeGuideClose.cloneNode(true);
      sizeGuideClose.parentNode.replaceChild(newCloseBtn, sizeGuideClose);

      newTrigger.addEventListener("click", function() {
        sizeGuideModal.classList.remove("opacity-0", "pointer-events-none");
        sizeGuideModal.querySelector(".transform").classList.remove("translate-y-4");
      });

      function closeModal() {
        sizeGuideModal.classList.add("opacity-0", "pointer-events-none");
        sizeGuideModal.querySelector(".transform").classList.add("translate-y-4");
      }

      newCloseBtn.addEventListener("click", closeModal);
      sizeGuideModal.addEventListener("click", function(e) {
        if (e.target === sizeGuideModal) {
          closeModal();
        }
      });
    }

    // 2. Quantity Selector Logic
    var qtyMinus = document.getElementById("qty-minus");
    var qtyPlus = document.getElementById("qty-plus");
    var qtyInput = document.getElementById("quantity");
    if (qtyMinus && qtyPlus && qtyInput) {
      var newQtyMinus = qtyMinus.cloneNode(true);
      var newQtyPlus = qtyPlus.cloneNode(true);
      qtyMinus.parentNode.replaceChild(newQtyMinus, qtyMinus);
      qtyPlus.parentNode.replaceChild(newQtyPlus, qtyPlus);

      newQtyMinus.addEventListener("click", function() {
        var val = parseInt(qtyInput.value) || 1;
        if (val > 1) {
          qtyInput.value = val - 1;
        }
      });
      newQtyPlus.addEventListener("click", function() {
        var val = parseInt(qtyInput.value) || 1;
        qtyInput.value = val + 1;
      });
    }

    // 3. Variant Selector Logic
    var variantSelectInput = document.getElementById("variant-id-input");
    var optionWrappers = document.querySelectorAll(".option-wrapper");
    var productPrice = document.getElementById("product-price");
    var comparePrice = document.getElementById("compare-price");
    var saleBadge = document.getElementById("sale-badge");
    var addToCartBtn = document.getElementById("add-to-cart-btn");
    
    var variants = [];
    var variantsEl = document.getElementById("product-variants-json");
    try {
      if (variantsEl) {
        variants = JSON.parse(variantsEl.textContent);
      }
    } catch(e) {
      console.error("Could not parse product variants JSON", e);
    }

    if (optionWrappers.length > 0 && variants.length > 0) {
      optionWrappers.forEach(function(wrapper) {
        var valueLabel = wrapper.querySelector(".option-value-label");
        var pills = wrapper.querySelectorAll(".variant-pill");
        
        pills.forEach(function(pill) {
          var newPill = pill.cloneNode(true);
          pill.parentNode.replaceChild(newPill, pill);

          newPill.addEventListener("click", function() {
            // Get fresh set of pills from parent wrapper
            var currentPills = wrapper.querySelectorAll(".variant-pill");
            
            // Remove active styles from siblings
            currentPills.forEach(function(p) {
              p.classList.remove("active-pill", "bg-primary", "text-on-primary", "border-primary", "ring-2", "ring-primary/20", "font-bold");
              p.classList.add("border-outline-variant");
              if (p.classList.contains("color-swatch")) {
                var check = p.querySelector(".checkmark");
                if (check) check.classList.add("hidden");
              }
            });
            
            // Add active styles to clicked
            newPill.classList.remove("border-outline-variant");
            newPill.classList.add("active-pill", "border-primary");
            if (newPill.classList.contains("color-swatch")) {
              newPill.classList.add("ring-2", "ring-primary/20");
              var check = newPill.querySelector(".checkmark");
              if (check) check.classList.remove("hidden");
            } else {
              newPill.classList.add("bg-primary", "text-on-primary");
            }

            // Update option label text
            var val = newPill.getAttribute("data-value");
            if (valueLabel) {
              var separator = wrapper.querySelector(".option-value-separator");
              if (isHexColor(val)) {
                valueLabel.textContent = '';
                if (separator) separator.textContent = '';
              } else {
                valueLabel.textContent = val;
                if (separator) separator.textContent = ': ';
              }
            }

            // Trigger sync
            updateSelectedVariant();
          });
        });
      });

      function updateSelectedVariant() {
        var selectedOptions = [];
        optionWrappers.forEach(function(wrapper, index) {
          var activePill = wrapper.querySelector(".variant-pill.active-pill");
          if (activePill) {
            selectedOptions[index] = activePill.getAttribute("data-value");
          }
        });

        // Find the matched variant
        var matchedVariant = variants.find(function(variant) {
          var match = true;
          selectedOptions.forEach(function(val, i) {
            if (variant.options[i] !== val) {
              match = false;
            }
          });
          return match;
        });

        if (matchedVariant) {
          variantSelectInput.value = matchedVariant.id;

          // Update Price
          if (productPrice) {
            productPrice.textContent = formatMoney(matchedVariant.price);
          }

          if (comparePrice && saleBadge) {
            if (matchedVariant.compare_at_price > matchedVariant.price) {
              comparePrice.textContent = formatMoney(matchedVariant.compare_at_price);
              comparePrice.classList.remove("hidden");
              
              // Calculate discount percentage
              const discountPercent = Math.round(((matchedVariant.compare_at_price - matchedVariant.price) * 100) / matchedVariant.compare_at_price);
              saleBadge.textContent = '-' + discountPercent + '%';
              saleBadge.classList.remove("hidden");
              
              if (productPrice) {
                productPrice.classList.add("text-red-600");
                productPrice.classList.remove("text-on-surface");
              }
            } else {
              comparePrice.classList.add("hidden");
              saleBadge.classList.add("hidden");
              if (productPrice) {
                productPrice.classList.remove("text-red-600");
                productPrice.classList.add("text-on-surface");
              }
            }
          }

          // Update Button State
          if (addToCartBtn) {
            var btnText = addToCartBtn.querySelector("span");
            if (matchedVariant.available) {
              addToCartBtn.disabled = false;
              addToCartBtn.classList.remove("opacity-50", "pointer-events-none");
              if (btnText) btnText.textContent = "Add to Cart";
            } else {
              addToCartBtn.disabled = true;
              addToCartBtn.classList.add("opacity-50", "pointer-events-none");
              if (btnText) btnText.textContent = "Sold Out";
            }
          }

          // Sync product image
          if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
            var mainImg = document.getElementById("main-product-image");
            if (mainImg) {
              mainImg.src = matchedVariant.featured_image.src;
            }
          }
        }
      }

      function formatMoney(cents) {
        const moneyFormat = (window.EzsportConfig && window.EzsportConfig.moneyFormat) || "${{amount}}";
        let value = (cents / 100).toFixed(2);
        return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
      }

      function isHexColor(val) {
        var cleaned = val.trim().replace(/\s+/g, '');
        if (/^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(cleaned)) {
          var lower = cleaned.toLowerCase();
          var knownNames = ['orange', 'purple', 'silver', 'yellow', 'violet', 'bronze', 'red', 'tan', 'white', 'black', 'green', 'brown', 'pink', 'grey', 'gray', 'gold', 'navy', 'blue', 'aqua', 'teal', 'lime', 'olive', 'plum'];
          if (knownNames.indexOf(lower) !== -1 || (lower.startsWith('#') && knownNames.indexOf(lower.substring(1)) !== -1)) {
            return false;
          }
          return true;
        }
        return false;
      }
    }
  }

  // Initialize immediately
  initProductSection();

  // Re-initialize when section is loaded/reloaded in Theme Editor
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('#product-form') || event.target.id.includes('product')) {
      initProductSection();
    }
  });
})();
